<div class="w-full">
  <div
    class="border-default bg-surface flex max-h-40 flex-wrap gap-2 overflow-y-auto rounded-lg border p-2">
    @for (item of values(); track item) {
      <div
        class="border-default bg-surface inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5">
        <p class="text-text-primary text-xs font-medium">{{ item }}</p>
        <button
          type="button"
          [disabled]="isDisabled()"
          (click)="removeItem(item)"
          class="text-text-tertiary hover:text-text-primary ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-50">
          <i [class]="ICONS.x" class="text-xs"></i>
        </button>
      </div>
    }
    <input
      type="text"
      class="text-text-primary placeholder-text-tertiary form-input min-w-[120px] flex-1 border-0 bg-transparent text-sm outline-none focus:ring-0"
      [id]="id()"
      [disabled]="isDisabled()"
      [value]="inputText()"
      placeholder="Type and press Enter…"
      (keydown)="onInputKeyDown($event)"
      (input)="onInputChange($event)" />
  </div>
</div>
